import { trackPortalFormSubmission } from '../Forms/tracking';
import { Root } from 'react-dom/client';
import { AddBizReactLoader } from '../../../Js/React/loader';
import ContainerRendererV2 from '../../../FrontEndReact/src/Core/Components/ContainerV2/ContainerRendererV2';
import { withFrontendContext } from '../../Common/frontendStateContext';
import { ContainerData, LegacyApiContainer, normalizeContainer } from '../../../FrontEndReact/src/Core/Types/containerV2';
import { ObjectType } from '../../../FrontEndReact/src/Core/Types/base';
import { bizLink } from '../../../FrontEndReact/src/Core/Types/bizLink';
import { getPathWithRootPath } from '../../../FrontEndReact/src/Core/Services/common';
import { goto } from '../../../Js/React/Services/legacy';

let root: Root | undefined;

type ContainerRefererType = 'BLOG' | 'CMS' | 'HTML5';

AddBizReactLoader(root, 'bizcontainerv2', (e) => {
	const params = (
		e.detail as {
			params: { container: LegacyApiContainer | ContainerData; refererType?: ContainerRefererType; refererId?: number };
		}
	).params;
	const containerData = 'placeholders' in params.container ? params.container : normalizeContainer(params.container);
	return withFrontendContext(
		<ContainerRendererV2
			container={containerData}
			objectType={mapRefererType(params.refererType)}
			objectId={params.refererId}
			clickHandler={clickHandler}
			onFormSubmissionSuccess={trackPortalFormSubmission}
		/>
	);
});

addLayoutComponent(3); //footer
addLayoutComponent(5); //cookie information
addLayoutComponent(7); //privacy policy
addLayoutComponent(10); //cookie policy

function addLayoutComponent(componentType: number) {
	const rootElementId = `bizcontainerv2-layout-component-${componentType}`;

	AddBizReactLoader(root, rootElementId, (e) => {
		const params = (e.detail as { params: { container: LegacyApiContainer | ContainerData } }).params;
		const containerData = 'placeholders' in params.container ? params.container : normalizeContainer(params.container);
		//legacy cannot handle multiple placeholders, we take the last one because that is how it works in legacy - no idea why...
		containerData.placeholders =
			containerData.placeholders.length > 1
				? [containerData.placeholders[containerData.placeholders.length - 1]]
				: containerData.placeholders;
		return withFrontendContext(
			<ContainerRendererV2
				container={containerData}
				clickHandler={clickHandler}
				onFormSubmissionSuccess={trackPortalFormSubmission}
			/>
		);
	});
}

function clickHandler(link: bizLink) {
	console.log('Module click handler received link:', link);
	if (link.type === 'legacy_state') {
		goto(link.href!);
	} else if (link.type === 'url') {
		if (!link.href) {
			return;
		}

		const href = resolveClickHandlerHref(link.href);
		if (link.target === '_blank') {
			window.open(href, '_blank', 'noopener,noreferrer');
		} else {
			window.location.href = href;
		}
	} else if (link.type === 'next_journey_item') {
		// Implement next journey item navigation if needed
		console.warn('Next journey item navigation is not implemented yet.');
	} else {
		console.error('Unknown link type:', link);
	}
}

function resolveClickHandlerHref(href: string): string {
	if (/^(https?:|mailto:|tel:|#)/i.test(href)) {
		return href;
	}

	return getPathWithRootPath(href);
}

function mapRefererType(refererType?: ContainerRefererType): ObjectType | undefined {
	if (refererType === 'BLOG') {
		return ObjectType.BlogPost;
	} else if (refererType === 'CMS') {
		return ObjectType.CMSPage;
	} else if (refererType === 'HTML5') {
		return ObjectType.OnlineEducation;
	}

	return undefined;
}
